import React from 'react';
import styled from '@emotion/styled';

export const IconCategories = () => {
  return (
    <StyledIconCategoriesSpan className="icon-svg IconCatories">
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.71306 4.06309L9.60806 7.37161C10.2129 8.06281 10.2129 9.09501 9.60806 9.78614L6.71313 13.0947C5.98268 13.9295 4.68406 13.9295 3.95364 13.0947L1.05868 9.78614C0.453855 9.09501 0.453851 8.06281 1.05866 7.37161L3.95364 4.06309C4.68406 3.22832 5.98267 3.22832 6.71306 4.06309Z"
          fill="white"
        />
        <path
          d="M8.66667 13.2456L11.9229 9.44669C12.3509 8.94736 12.3509 8.21056 11.9229 7.71123L8.66667 3.91229"
          stroke="white"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M11.3333 13.2456L14.5896 9.44669C15.0175 8.94736 15.0175 8.21056 14.5896 7.71123L11.3333 3.91229"
          stroke="white"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </svg>
    </StyledIconCategoriesSpan>
  );
};

const StyledIconCategoriesSpan = styled.span`
  margin: 8px 3px 0px 0px;
`;
